const respuestasFalsas = {
    direccion: [
        'PJE DEL CAMPO 4480',            
        'PJE ELIZALDE 6323',             
        'OMBU 2110',                     
        'B.ORDO#EZ 5800-FINAL',          
        'MEDRANO 3342',                  
        'SORRENTO 1620',                 
        'GRANDOLI 2875',                 
        'J B  GONZALEZ 251',             
        'SUPERI 1410',                   
        'SCHWEITZER 8071 T38 P2 D1',     
        'PJE COLIAN 6183 (EX 510)',      
        'PTE ROCA 4715',                 
        'PJE BRASIL 1435',               
        'PARAGUAY 5846 B',               
        'J.B.GONZALEZ 159',              
        'DORREGO 585',                   
        'LARRECHEA 1772',                
        'ANCHORENA 1789',                
        'VIEYTES 2865',                  
        'J J PEREZ 2703 (VIVERO)',       
        'PJE GRECIA 2428',               
        'PASCO 1332 P1 DTO 1',           
        'JOSE MARQUEZ 456',              
        'DEAN FUNES 3830',               
        'DR RIVA 365 NEGOCIO',           
        'PJE CULACIATTI 6082',           
        'AVALOS 1837 PASILLO 4',         
        'SUIPACHA 5196',                 
        'HUTCHINSON 3768',               
        'SOLDATI 6094',                  
        'PABLO VI 738',                  
        'AVELLANEDA 3708',               
        'GENOVA 2317',                   
        'MEDRANO 1096',                  
        'PJE 1 NRO 1682',                
        'PASCO 6690',                    
        'GURUCHAGA 863',                 
        'ESMERALDA 3878',                
        'AV.GENOVA 2469',                
        'URIARTE 817',                   
        'FRENCH 2907',                   
        'ARIJON 1449',                   
        'LEIVA 5244 DTO 2',              
        'MEDRANO 2238',                  
        'RODRIGUEZ 3050 P1 A',           
        'COMERCIO 1721',                 
        'PJ AUSTRALIA 4645',             
        'POLLEDO 2578',                  
        'BV ORO#O 4536 DT C',            
        'S.DE BUSTAMANTE 101 NEGOCIO',   
        'SANTIAGO DEL ESTERO 280',       
    ],
    plan:[
        "BO",
        "4700",
        "PASI",
        "100",
        "PSF",
        "325",
        "TPU",
        "EI",
        "324A",
        "121FI",
        "420",
        "CI",
        "1000I",
        "PDI",
        "480",
        "IIB",
        "470",
        "BS",
        "I+PROM",
        "600P",
        "UPJET",
        "KE",
        "4600",
        "421F",
        "RDUI",
        "420I",
        "CF",
        "4800",
        "CAP",
        "PAS",
        "EXTRAI",
        "O",
        "121",
        "E+I",
        "30 P",
        "P",
        "KC3",
        "121I",
        "150",
        "PD",
        "326F",
        "GLOBAL",
        "RU",
        "PPB",
        "PRADOB"
    ],
    apellido_nombres: [
        "NIEVA SEGUNDO A",
        "CORONEL NICOLAS F",
        "LIRUSSO ANGEL A",
        "VEGA NATALIA",
        "DIAZ ROXANA",
        "FIORE ARANZA",
        "BAEZ LORENZA",
        "CARBALLO JUANA",
        "LUGO JUAN N",
        "LUGO EMILIO",
        "GONZALEZ MARIELA ANGELICA",
        "BELDANO ELISEO",
        "BELDANO PEDRO",
        "JUAREZ JUAN GETULIO",
        "PINOLINI DANIEL A",
        "MAIDANA VIRILIA",
        "MARTINEZ EVARISTA",
        "VEGA ALBERTO",
        "DIAZ VERONICA",
        "DIAZ PABLO",
        "VEGA ALBERTO EZEQUIEL",
        "REDIGONDA GUSTAVO",
        "GUTIERREZ SABRINA",
        "GAITAN MARISA",
        "GAITAN JUAN A",
        "ALCOBER BARBARA",
        "ATENCIO ROSA",
        "ALCOBER LEONEL",
        "LOZANO FABRICIO",
        "ALTAMIRANO JUAN E",
        "ALTAMIRANO MARIANA",
        "ALTAMIRANO PABLO",
        "GONZALEZ RAMONA",
        "LUNA ELSA",
        "LES NATALIA CECILIA",
        "LES FLORENCIA SOL",
        "LES MATIAS",
        "ALFONSO CAMILA",
        "LES MAURO N",
        "LES MORA VALENTINA",
        "GALASSO DOMINGO",
        "GALASSO GABRIELA",
        "FERRE LARA",
        "FERRE ANA"
    ],
    questions :[
        'Su domicilio actual es...',
        '¿Cual es su nombre completo?',
        'Su plan es...'
      ]
}


export default respuestasFalsas